"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaymentForm = void 0;

var react_1 = __importStar(require("react"));

var PaymentForm_styles_1 = require("./PaymentForm.styles");

var DisplayMessage_1 = require("../DisplayMessage");

var CountrySelector_1 = require("../CountrySelector");

var InputField_1 = require("../InputField");

var PaymentForm_utils_1 = require("./PaymentForm.utils");

var Label_1 = require("../Label");

var settings_1 = require("../../settings");

var CouponInput_1 = require("../CouponInput");

var Button_1 = require("../Button");

var PaymentFormInputField = InputField_1.InputField;
var PaymentFormCouponInput = CouponInput_1.CouponInput;

var PaymentForm = function PaymentForm(_a) {
  var errorMessage = _a.errorMessage,
      successMessage = _a.successMessage,
      form = _a.form,
      formValues = _a.formValues,
      errors = _a.errors,
      showCurrencyWarning = _a.showCurrencyWarning,
      handleSubmit = _a.handleSubmit,
      handleChange = _a.handleChange,
      handleToggle = _a.handleToggle,
      handleApplyDiscount = _a.handleApplyDiscount,
      isSubmitting = _a.isSubmitting,
      renderCardInput = _a.renderCardInput,
      submitButtonText = _a.submitButtonText,
      price = _a.price,
      taxMessage = _a.taxMessage,
      collapsedBreakpoint = _a.collapsedBreakpoint,
      _b = _a.hide,
      hide = _b === void 0 ? {} : _b,
      priceMessage = _a.priceMessage,
      priceMessageForTotal = _a.priceMessageForTotal,
      errorShouldReplaceLabel = _a.errorShouldReplaceLabel,
      useUpdateBillingForm = _a.useUpdateBillingForm,
      submitButtonStyle = _a.submitButtonStyle,
      _c = _a.hideCouponLabel,
      hideCouponLabel = _c === void 0 ? false : _c;
  var Button = settings_1.settings.DefaultButton;
  var hideCouponField = hide.couponCode !== undefined ? hide.couponCode : true;
  react_1.useEffect(function () {
    if (errorMessage) {
      window === null || window === void 0 ? void 0 : window.scroll({
        top: 0,
        behavior: 'smooth'
      });
    }
  }, [errorMessage]);

  var hasCountryError = function hasCountryError() {
    return Boolean(errors.country) && !hide.country;
  };

  return react_1.default.createElement(PaymentForm_styles_1.Form, {
    onSubmit: handleSubmit,
    ref: form
  }, errorMessage && react_1.default.createElement(DisplayMessage_1.DisplayMessage, {
    "data-testid": "payment_error"
  }, errorMessage), successMessage && successMessage.length > 0 && react_1.default.createElement(DisplayMessage_1.DisplayMessage, {
    type: DisplayMessage_1.DisplayMessageType.SUCCESS,
    "data-testid": "payment_success"
  }, successMessage), react_1.default.createElement(PaymentForm_styles_1.FieldWrapper, {
    collapsedBreakpoint: collapsedBreakpoint
  }, react_1.default.createElement(PaymentForm_styles_1.Column, null, react_1.default.createElement(PaymentFormInputField, {
    hide: hide.firstName,
    value: formValues.firstName,
    error: errors.firstName,
    label: "First name",
    id: "firstName",
    "data-recurly": "first_name",
    onChange: function onChange(_a) {
      var target = _a.target;
      return handleChange('firstName', target.value);
    },
    errorShouldReplaceLabel: errorShouldReplaceLabel
  })), react_1.default.createElement(PaymentForm_styles_1.Column, null, react_1.default.createElement(PaymentFormInputField, {
    hide: hide.lastName,
    value: formValues.lastName,
    error: errors.lastName,
    label: "Last name",
    id: "lastName",
    "data-recurly": "last_name",
    errorShouldReplaceLabel: errorShouldReplaceLabel,
    onChange: function onChange(_a) {
      var target = _a.target;
      return handleChange('lastName', target.value);
    }
  }))), !useUpdateBillingForm && react_1.default.createElement(PaymentFormInputField, {
    hide: hide.email,
    value: formValues.email,
    error: errors.email,
    label: "Email",
    id: "email",
    "data-recurly": "email",
    onChange: function onChange(_a) {
      var target = _a.target;
      return handleChange('email', target.value);
    },
    errorShouldReplaceLabel: errorShouldReplaceLabel
  }), showCurrencyWarning && react_1.default.createElement(DisplayMessage_1.DisplayMessage, {
    type: DisplayMessage_1.DisplayMessageType.WARNING,
    "data-testid": "currency_warning",
    style: {
      marginTop: '1rem'
    }
  }, react_1.default.createElement("div", {
    "data-testid": "currency-changed-message"
  }, "Your currency has been changed to", ' ', PaymentForm_utils_1.getCurrencyFromCountryCode(formValues.country), ".")), react_1.default.createElement(PaymentForm_styles_1.FieldWrapper, {
    collapsedBreakpoint: collapsedBreakpoint
  }, react_1.default.createElement(PaymentForm_styles_1.Column, null, react_1.default.createElement(PaymentFormInputField, {
    hide: hide.street,
    value: formValues.street,
    error: errors.street,
    label: "Address Line 1",
    id: "street",
    "data-recurly": "address1",
    onChange: function onChange(_a) {
      var target = _a.target;
      return handleChange('street', target.value);
    },
    errorShouldReplaceLabel: errorShouldReplaceLabel
  })), react_1.default.createElement(PaymentForm_styles_1.Column, null, react_1.default.createElement(PaymentFormInputField, {
    hide: hide.street2,
    value: formValues.street2,
    error: errors.street2,
    id: "street2",
    label: "Address Line 2",
    "data-recurly": "address2",
    onChange: function onChange(_a) {
      var target = _a.target;
      return handleChange('street2', target.value);
    },
    errorShouldReplaceLabel: errorShouldReplaceLabel
  }))), react_1.default.createElement(PaymentForm_styles_1.FieldWrapper, {
    collapsedBreakpoint: collapsedBreakpoint
  }, react_1.default.createElement(PaymentForm_styles_1.Column, null, react_1.default.createElement(PaymentFormInputField, {
    hide: hide.city,
    value: formValues.city,
    error: errors.city,
    label: "City",
    id: "city",
    "data-recurly": "city",
    onChange: function onChange(_a) {
      var target = _a.target;
      return handleChange('city', target.value);
    },
    errorShouldReplaceLabel: errorShouldReplaceLabel
  })), react_1.default.createElement(PaymentForm_styles_1.Column, null, react_1.default.createElement(PaymentFormInputField, {
    hide: hide.region,
    value: formValues.region,
    error: errors.region,
    id: "region",
    label: "State or Region",
    "data-recurly": "state",
    onChange: function onChange(_a) {
      var target = _a.target;
      return handleChange('region', target.value);
    },
    errorShouldReplaceLabel: errorShouldReplaceLabel
  }))), react_1.default.createElement(PaymentForm_styles_1.FieldWrapper, {
    collapsedBreakpoint: collapsedBreakpoint
  }, react_1.default.createElement(PaymentForm_styles_1.Column, null, react_1.default.createElement(PaymentFormInputField, {
    hide: hide.postalCode,
    value: formValues.postalCode,
    error: errors.postalCode,
    id: "postalCode",
    label: "Zip/Postal Code",
    "data-recurly": "postal_code",
    onChange: function onChange(_a) {
      var target = _a.target;
      return handleChange('postalCode', target.value);
    },
    errorShouldReplaceLabel: errorShouldReplaceLabel
  })), react_1.default.createElement(PaymentForm_styles_1.Column, null, react_1.default.createElement(CountrySelector_1.CountrySelector, {
    id: "country",
    label: price ? 'Country' : 'Loading...',
    error: errors.country,
    "data-recurly": "country",
    value: formValues.country,
    hide: hide.country,
    disabled: price === undefined && errors.country === undefined,
    onChange: function onChange(_a) {
      var target = _a.target;
      return handleChange('country', target.value);
    },
    errorShouldReplaceLabel: errorShouldReplaceLabel
  }))), react_1.default.createElement(PaymentForm_styles_1.Spacer, null), react_1.default.createElement(Label_1.Label, {
    label: "Card details"
  }), renderCardInput(), !useUpdateBillingForm && react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(PaymentFormCouponInput, {
    hide: hideCouponField,
    hideCouponLabel: hideCouponLabel,
    value: formValues.couponCode,
    error: errors.couponCode,
    label: "I have a coupon code",
    labelOpen: "I don't have a coupon code",
    id: "couponCode",
    onToggle: handleToggle,
    onChange: function onChange(_a) {
      var target = _a.target;
      return handleChange('couponCode', target.value);
    },
    errorShouldReplaceLabel: errorShouldReplaceLabel,
    handleApplyDiscount: handleApplyDiscount
  }), react_1.default.createElement(PaymentForm_styles_1.Spacer, null), errors.country === undefined && react_1.default.createElement("div", {
    "data-testid": "tax_preview"
  }, priceMessage ? priceMessage : price ? react_1.default.createElement(react_1.default.Fragment, null, priceMessageForTotal || 'You will be billed ', "" + price.currencySymbol + price.total + " ", ' ', react_1.default.createElement("span", {
    id: "tax-message"
  }, taxMessage)) : 'Loading price...')), react_1.default.createElement(PaymentForm_styles_1.Spacer, null), react_1.default.createElement(PaymentForm_styles_1.Spacer, null), react_1.default.createElement(Button, {
    id: "submit-payment",
    "data-testid": "submit-payment",
    disabled: hasCountryError() || isSubmitting,
    variant: isSubmitting ? Button_1.ButtonVariant.LOADING : Button_1.ButtonVariant.PRIMARY,
    submitButtonStyle: submitButtonStyle
  }, submitButtonText));
};

exports.PaymentForm = PaymentForm;